'use client';

import { useEffect, useRef, useState } from 'react';
import PricingSectionV2 from './PricingSectionV2/PricingSectionV2';
import styles from './Pricing.module.css';
import { trackEvent } from '@/lib/analytics/firebaseAnalytics';
import { AnalyticsEvents } from '@/lib/analytics/events';

const Pricing = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [hasTrackedView, setHasTrackedView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasTrackedView) {
            trackEvent(AnalyticsEvents.VIEW_PRICING_SECTION);
            setHasTrackedView(true);
          }
        });
      },
      { threshold: 0.3 } // Trigger when 30% visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasTrackedView]);

  return (
    <section
      ref={sectionRef}
      className={styles.pricing}
      id="pricing"
      aria-labelledby="pricing-heading"
    >
      <div className={styles.container}>
        <PricingSectionV2 mode="landing" />
      </div>
    </section>
  );
};

export default Pricing;
